module.exports = __webpack_public_path__ + "static/img/zus_logo.6e014bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/zus_logo.png
// module id = xgw5
// module chunks = 0